"use strict";

exports.__esModule = true;
exports.TimelineDataSourceField = TimelineDataSourceField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TimelineDataSourceField(props) {
  var setProp = props.setProp,
    value = props.value,
    sources = props.sources;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  if (!value && sources && sources.length) {
    setProp(sources[0].value);
  }
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("TimelineDataSourceField.label", "Timeline Data Source"),
    helperText: translate("TimelineDataSourceField.advancedDataSource.helperText", "Select the data to display in the table.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: value,
    onChange: function onChange(e) {
      return setProp(e.target.value || undefined);
    }
  }, sources.map(function (source) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      "data-testid": "TimelineDataSource." + source.value,
      key: source.value,
      value: source.value
    }, source.name);
  }))));
}